import { Tabs, TabsList, TabsTrigger } from '../Tabs';
import { Tooltip } from '../Tooltip';

/**
 * CHIPS DE MARCO — D0 · D1 · D3 · D7 · D15 · D30 · D60 · D90.
 *
 * É uma variante do `Tabs segmented`, não um componente novo de interação: setas, Home/End e
 * foco vêm de lá. Marco que ainda não venceu fica DESABILITADO e explica por quê no tooltip
 * ("Ainda não deu tempo: as primeiras entradas são de 3 dias atrás") — o motivo vem pronto do
 * servidor.
 */
export interface MilestoneChip {
  value: number;
  /** Por que está desabilitado. `null`/ausente = habilitado. */
  disabledReason?: string | null;
}

export interface MilestoneChipsProps {
  chips: readonly MilestoneChip[];
  value: number;
  onValueChange: (value: number) => void;
  /** Nome do grupo para leitor de tela. */
  label?: string;
}

export function MilestoneChips({
  chips,
  value,
  onValueChange,
  label = 'Marco da evasão',
}: MilestoneChipsProps) {
  return (
    <Tabs variant="segmented" value={String(value)} onValueChange={(v) => onValueChange(Number(v))}>
      <TabsList label={label}>
        {chips.map((chip) => {
          const trigger = (
            <TabsTrigger
              key={chip.value}
              value={String(chip.value)}
              disabled={Boolean(chip.disabledReason)}
              className="nums"
            >
              D{chip.value}
            </TabsTrigger>
          );
          return chip.disabledReason ? (
            <Tooltip key={chip.value} content={chip.disabledReason}>
              <span
                tabIndex={0}
                aria-label={`D${chip.value}: ${chip.disabledReason}`}
                className="inline-flex"
              >
                {trigger}
              </span>
            </Tooltip>
          ) : (
            trigger
          );
        })}
      </TabsList>
    </Tabs>
  );
}
